import { fetchWrapper, getSequenceNumber } from '@/_helpers';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

export const handleFormSubmission = async ({
    data,
    form,
    userFormDataId,
    formType,
    roomId,
    position,
    user,
    team,
    currRoom,
    submitMode = true,
    selectedUserOption = [],
    setIsSubmitting = () => {},
    sharedFormSubmission, // anonymous form submission
    sharedUserFormDataSubmission, // anonymous/user - userformdata submission
    sharedFormId,
    sharedUserFormDataId,
    visibleTo,
}) => {
    try {
        if (formType === 'sos' && currRoom && currRoom?.client) {
            const serviceId = JSON.parse(
                data[Object.keys(data)?.find((key) => key.startsWith('ServiceRadio'))] || '{}'
            ).id;
            const availableUnits =
                currRoom?.client?.availableUnits?.find((clientUnitData) => clientUnitData?.service === serviceId)
                    ?.amount || 0;
            if (availableUnits < 10) {
                const title =
                    availableUnits >= 0
                        ? `Client has only ${availableUnits} units for the selected service. Are you sure you want to continue?`
                        : `Client has ${
                              availableUnits * -1
                          } credited units for selected service. Are you sure you want to continue?`;
                const result = await Swal.fire({
                    title,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, continue',
                });
                if (!result.isConfirmed) {
                    return;
                }
            }
        }
        const keys = Object.keys(data);
        const form_data = new FormData();
        form_data.append('visibleTo', visibleTo);
        for (let i = 0; i < keys.length; i++) {
            const formInfo = form.data.find((form) => form._id === keys[i].split('-')[1]);
            form_data.append(`fieldName[${i}]`, keys[i]);

            form_data.append(
                `value[${i}]`,
                typeof data[keys[i]] === 'object'
                    ? keys[i].split('-')[0] === 'Image' ||
                      keys[i].split('-')[0] === 'File' ||
                      keys[i].split('-')[0] === 'AudioFile'
                        ? data[keys[i]][0]
                        : JSON.stringify(data[keys[i]])
                    : formInfo.type === 'date'
                      ? data[keys[i]].replace(/\//g, '-')
                      : data[keys[i]]
            );
            form_data.append(`type[${i}]`, formInfo ? formInfo.type : 'image');
            form_data.append(`label[${i}]`, formInfo ? formInfo.key : 'image');
        }

        if (position?.coords) {
            form_data.append(
                `location`,
                JSON.stringify({ lat: position.coords.latitude, lng: position.coords.longitude })
            );
        }
        if (sharedFormSubmission && sharedFormId) {
            return fetchWrapper.post(`shared-forms/${sharedFormId}/userFormData`, form_data, true, false);
        }
        if (sharedUserFormDataSubmission && sharedUserFormDataId) {
            if (user && user?._id) {
                form_data.append('user', user._id);
            }
            form_data.append('submissionType', submitMode ? 'completed' : 'draft');
            return fetchWrapper.post(
                `shared-userformdata/${sharedUserFormDataId}/userFormData`,
                form_data,
                true,
                false
            );
        }

        form_data.append(`formType`, formType ? formType : 'normal');
        form_data.append(`form`, form._id);
        form_data.append(`chatroom`, roomId);
        form_data.append(`user`, localStorage.getItem('userId'));
        form_data.append('submissionType', submitMode ? 'completed' : 'draft');

        if (formType === 'eos' || formType === 'sos') {
            if (!position) {
                toast.error('User Location is required for sos/eos form! Please turn on location and refresh.');
                return;
            }
            if (!team.provider?._id) {
                toast.error('Oops! this team is not registered as a Provider Team. Please contact your Supervisor');
                return;
            }

            if (!currRoom?.client?.id) {
                toast.error(
                    'Oops! this channel is not registered as a Client channel. Please contact your Supervisor.'
                );
                return;
            }

            form_data.append(`SequenceID`, getSequenceNumber());
            form_data.append(`provider`, team.provider._id);
            form_data.append(`client`, currRoom.client.id);
        } else if (formType === 'multipleSubmission') {
            if (selectedUserOption.length === 0) {
                if (submitMode === 'completed') {
                    setIsSubmitting(false);
                    return toast.error('Please select at least one form participant');
                }
            }
            for (let i = 0; i < selectedUserOption.length; i++) {
                form_data.append('submissionRequiredBy[]', selectedUserOption[i]);
            }
        } else if (!form.isLocationOptional) {
            if (!position || !position?.coords) {
                toast.error('User Location is required for this form! Please turn on location and refresh.');
                return;
            }
        }

        let response;
        if (userFormDataId) {
            response = await fetchWrapper.put(`userFormData/${userFormDataId}`, form_data, true);
        } else {
            response = await fetchWrapper.post('userFormData', form_data, true);
        }
        return response;
    } catch (e) {
        console.error(e, 'FORM SUBMITTED ERROR:handleFormSubmission');
        toast.error(e.message);
    }
};

export const scrollToTopOnNavigation = () => {
    let scrollToElement;
    const modalTitles = document.getElementsByClassName('modal-header');
    if (modalTitles.length === 1) {
        scrollToElement = modalTitles[0];
    } else if (modalTitles.length === 2) {
        scrollToElement = modalTitles[1];
    } else {
        scrollToElement = document.getElementById('viewform.staticform');
    }
    if (scrollToElement) {
        scrollToElement.scrollIntoView({ behavior: 'smooth' });
    }
};
